import type React from 'react';

import Button from 'components/partials/button/button';
import Heading from 'components/partials/heading/heading';

import Icons from 'assets/icons';

interface NoMessagesContentProps {
  onPropositionClick: (description: string) => void;
  isReadOnly?: boolean;
}

const propositions = [
  {
    id: 1,
    title: 'Review your last meeting',
    description: 'What were the takeaways from my last call?',
  },
  {
    id: 2,
    title: 'Check in on progress towards goals',
    description: 'What is the biggest YOY change in my 2026 deposit pool?',
  },
  {
    id: 3,
    title: 'Look ahead to future classes',
    description:
      'How does my Entering Class 2027 compare to the rest of the market?',
  },
];

const NoMessagesContent = ({
  onPropositionClick,
  isReadOnly,
}: NoMessagesContentProps): React.JSX.Element => (
  <div className="w-full flex flex-col items-center justify-center gap-4">
    <div className="flex flex-col items-center gap-4">
      <Icons.MarkLogo className="size-20" role="img" aria-label="MARK" />

      <div className="flex flex-col items-center gap-1 text-navy-800">
        <Heading variant="h3">Hi! I'm MARK - your insights analyst.</Heading>
        <p className="text-base leading-6 text-center">
          <b>Monitor </b>
          your Critical Elements, <b>Analyze </b>
          your performance, <b>Report </b>
          to stakeholders, and <b>Know </b>
          how you compare.
        </p>
      </div>
    </div>

    <div className="w-full grid grid-cols-3 gap-4">
      {propositions.map((proposition) => (
        <Button
          key={proposition.id}
          variant="reserve-outlined"
          className="flex flex-col items-start justify-start gap-1 w-full min-w-0 p-4 border border-navy-100 whitespace-normal"
          onClick={() => onPropositionClick(proposition.description)}
          disabled={isReadOnly}
        >
          <span className="text-sm font-semibold text-gray-700 leading-5 break-words w-full text-left">
            {proposition.title}
          </span>
          <span className="text-sm text-gray-500 font-normal leading-5 break-words w-full text-left">
            {proposition.description}
          </span>
        </Button>
      ))}
    </div>
  </div>
);

export default NoMessagesContent;
